// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__Y6gTx","overflowing":"ReadFullNote_overflowing__2A3o6"};